import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from './toast.service';

@Component({
  standalone: true,
  selector: 'app-toasts',
  imports: [CommonModule],
  styles: [
    `
    .toasts-wrap { position: fixed; right: 1rem; bottom: 1rem; z-index: 1080; display: flex; flex-direction: column; gap: .5rem; }
    .toast-item { border-radius: 8px; padding: .5rem .75rem; box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
    .toast-success { background: #d1e7dd; color: #0f5132; border: 1px solid #badbcc; }
    .toast-error { background: #f8d7da; color: #842029; border: 1px solid #f5c2c7; }
    .toast-info { background: #cff4fc; color: #055160; border: 1px solid #b6effb; }
    [data-bs-theme="dark"] .toast-success { background: #114c39; color: #d1f2e4; border-color: #0d3a2c; }
    [data-bs-theme="dark"] .toast-error { background: #5c1f25; color: #f7d9dc; border-color: #4a191e; }
    [data-bs-theme="dark"] .toast-info { background: #0b3d45; color: #d6f6fb; border-color: #093238; }
    button.close { background: none; border: 0; color: inherit; }
    `
  ],
  template: `
<div class="toasts-wrap" aria-live="polite" aria-atomic="true">
  <div *ngFor="let t of toastSvc.toasts()" class="toast-item" [ngClass]="{
    'toast-success': t.type==='success', 'toast-error': t.type==='error', 'toast-info': t.type==='info'
  }">
    <div class="d-flex align-items-start gap-2">
      <div class="flex-grow-1">{{ t.message }}</div>
      <button class="close" (click)="toastSvc.dismiss(t.id)" aria-label="Schließen">×</button>
    </div>
  </div>
  
</div>
  `
})
export class ToastsComponent {
  constructor(public toastSvc: ToastService) {}
}

